var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"round"},[_c('input',{staticClass:"no-message",attrs:{"type":"checkbox","id":'checkbox-'+_vm.checkboxKey},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('change')}}}),_c('label',{class:{'error-days': _vm.error},attrs:{"data-letter":_vm.text,"for":'checkbox-'+_vm.checkboxKey}})])
}
var staticRenderFns = []

export { render, staticRenderFns }